(function () { 
    
  $(".flexslider.default")
    .flexslider({
      animation: "slide",
      animationLoop: false,
      smoothHeight: false,
      directionNav: true,
      prevText: "",
      nextText: "", 
      video: true, 
      slideshow: false,
      start: function(slider){
        var active_slide = slider.find("li.flex-active-slide");
        galleryTextSlide(active_slide);
        initSection();
      },
      after: function(slider){
        var active_slide = slider.find("li.flex-active-slide");
        galleryTextSlide(active_slide);    

        const video = active_slide.find("video").get(0);
        if (video) {
          video.muted = true;
          video.play();
        } 
      },
      before: function(slider){
        slider.find(".button--sound").removeClass('active');  
      }
  });

  var slideCount = $(".flexslider.social").find("li").length;
  $(".flexslider.social")
    .flexslider({
      animation: "slide",
      smoothHeight: false,
      directionNav: false,
      animationLoop: false,
      prevText: "",
      nextText: "", 
      animationSpeed: 500,
      video: true, 
      slideshow: false,
      touch: true,
      startAt: (slideCount > 1 ? 1 : 0),
      start: function(slider){
        var active_slide = slider.find("li.flex-active-slide");
        galleryTextSlide(active_slide);
        initSection();
      },
      after: function(slider){
        var active_slide = slider.find("li.flex-active-slide");
        galleryTextSlide(active_slide);
      },
      before: function(slider){
        slider.find(".button--sound").removeClass('active');  
      }
  });
  
  $(document).on('click', '.flexslider .slides > li', function (e) {
    if ($(e.target).closest('a, .button--sound').length) return;

    var slider = $(this).closest('.flexslider').data('flexslider');
    var index  = $(this).index(); // exact slide index when no clones
    slider && slider.flexAnimate(index);
  });
  
	const stopVideo = (section) => {
    const slides = section.querySelectorAll('.slideshow-with-text__slide');
    const soundButtons = section.querySelectorAll('.carousel-sound-video');

    slides.forEach(card => {
      const v = card.querySelector('video');
      // only pause if this slide is NOT the active one
      if (v && !card.classList.contains('active-slide')) {
        v.pause();
      }
    });

    soundButtons.forEach(btn => btn.classList.remove('active'));
  };

	const playVideo = (section, width) => {
    const videos = section.querySelectorAll('video');
		const cards = section.querySelectorAll('.slideshow-with-text__slide');

		if (videos && cards) {
			cards.forEach(card => {
				if (card.querySelector('video')) {
					if (card.classList.contains('active-slide')){
						card.querySelector('video').play();
                        card.querySelector('video').muted = true;
                    }
					else 
						card.querySelector('video').pause();
				}
			});
		} 
  }

    const galleryTextSlide = (active_slide) => {	
        active_slide.addClass("active-slide");
        active_slide.siblings(".slideshow-with-text__slide").removeClass("active-slide");

        playVideo(active_slide.closest('.slideshow-with-text-section')[0], document.documentElement.clientWidth);
	};

	const initSection = () => {
		const sections = document.querySelectorAll('.slideshow-with-text-section');
      
        const options = {
              threshold: 0.75
        };
		const sectionObserver = new IntersectionObserver(
          (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) 
                playVideo(entry.target, entry.boundingClientRect.width);
            else 
                stopVideo(entry.target);
          })
		}, options);


		sections.forEach(section => {
          sectionObserver.observe(section);
        });
	}

    // sound control

  const controlsVideo = () => {
    const buttonsSound = document.querySelectorAll('.carousel-sound-video');
    const allVideos = document.querySelectorAll('.slides video');

    buttonsSound.forEach((button) => {
      button.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const slide = button.closest('li.slide_video');
        if (!slide) return;

        const video = slide.querySelector('video');
        if (!video) return;

        if (video.muted) {
          allVideos.forEach(v => (v.muted = true));
          document.querySelectorAll('.carousel-sound-video').forEach(b => b.classList.remove('active'));
          setTimeout(() => { video.muted = false; }, 10);
        } else {
          setTimeout(() => { video.muted = true; }, 10);
        }
        button.classList.toggle('active');
      };
    });
  };

	document.addEventListener("shopify:section:load", function () {
		controlsVideo();
	});	 

    setTimeout(() => {
		controlsVideo();
	}, 100)
  
    $window = $(window);
	var viewport = window.innerWidth;
  
    $window.resize(function() {
		viewport = window.innerWidth;
	});

    if(viewport < 750){
      $( '.slideshow-with-text__text' ).each(function( index ) {
        var slideTextCollapsedHeight = $(this).find('.slideshow-with-text__text_wrap >:first-child').height();
        var slideTextMaxHeight = $(this).find('.slideshow-with-text__text_wrap').height();
        $(this).find('.slideshow-with-text__text_wrap').height(slideTextCollapsedHeight).toggleClass('collapsed');      
  
        $(this).find( '.toggle-button' ).on('click', function(e){
          e.preventDefault();
          $(this).text( $(this).text() == "Read More +" ? "Read Less -" : "Read More +" );
          $(this).toggleClass('active');
      
          if($(this).closest('.slideshow-with-text__text').find('.slideshow-with-text__text_wrap').hasClass('collapsed')){
              $(this).closest('.slideshow-with-text__text').find('.slideshow-with-text__text_wrap').animate({height: slideTextMaxHeight}, 500);
          }
          else{
              $(this).closest('.slideshow-with-text__text').find('.slideshow-with-text__text_wrap').animate({height: slideTextCollapsedHeight}, 500);
          }
          $(this).closest('.slideshow-with-text__text').find('.slideshow-with-text__text_wrap').toggleClass('collapsed');
        });
      });
    }

    window.addEventListener('blur', (event) => {
      const buttonsSound = document.querySelectorAll('.carousel-sound-video');
      const allVideos = document.querySelectorAll('.slides video');

      // mute all videos
      allVideos.forEach(videoElement => {
          videoElement.muted = true
      });
      buttonsSound.forEach(buttonElement => {
        buttonElement.classList.remove('active');
      });
	})
})();
